import { resetRoute, showView } from '../actions/publicActions';
import { mutator } from 'satcheljs';
import getStore from '../store/store';

mutator(showView, actionMessage => {
    getStore().displayedView = actionMessage.displayedView;
    getStore().itemId = actionMessage.itemId;
    getStore().account = actionMessage.account;
    getStore().iCalUId = actionMessage.iCalUId;
    getStore().formId = actionMessage.formId;
});

mutator(resetRoute, () => {
    getStore().displayedView = undefined;
});
